import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M10.3 7.82H5.7a.683.683 0 0 1-.679-.679c0-.37.308-.678.678-.678h4.602c.37 0 .678.308.678.678 0 .37-.308.678-.678.678Zm-2.512 3.163H5.699a.683.683 0 0 1-.678-.678c0-.37.308-.678.678-.678h2.089c.37 0 .678.308.678.678 0 .37-.308.678-.678.678Z" }, null, -1), h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M10.4 2.151h1.628v-.009c.696 0 1.256.57 1.256 1.257v10.64a1.26 1.26 0 0 1-1.256 1.256H3.973a1.26 1.26 0 0 1-1.257-1.256V3.408c0-.696.57-1.257 1.257-1.257H5.59v-.768c0-.371.307-.678.678-.678h3.453c.371 0 .678.307.678.678v.768Zm-1.347-.09H6.956v.949h2.097v-.95Zm-4.98 11.878h7.846V3.507H10.4v.18a.683.683 0 0 1-.678.679H6.27a.683.683 0 0 1-.678-.678v-.18h-1.52v10.431Z",
  "clip-rule": "evenodd"
}, null, -1), l = [
  n,
  h
];
function d(r, s) {
  return t(), c("svg", o, [...l]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
